import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { ProductVisualView } from './ProductVisualView';
import type { ProductFeature } from '../../types/product';
type FeatureRowsProps = {
  heading: string;
  subheading: string;
  items: ProductFeature[];
};
export function FeatureRows({
  heading,
  subheading,
  items
}: FeatureRowsProps) {
  return <section className="w-full bg-white pb-20" aria-labelledby="features-heading" data-id="element-1046" data-mp="s22pw5vpjdwf">
      <div className="mx-auto max-w-shell px-6" data-id="element-1047" data-mp="wtb0344v33an">
        <SectionHeading id="features-heading" title={heading} subtitle={subheading} data-id="element-1048" data-mp="wu2voeygl10x" />

        <div className="mt-14 space-y-16 lg:space-y-8" data-id="element-1049" data-mp="j2xqkxcbngj7">
          {items.map((feature, index) => {
          const visualFirst = index % 2 === 0;
          return <article key={feature.title} className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16" data-id="element-1050" data-mp="94037xqmtt1s" data-mpi={index}>
                <div className={`flex min-h-[340px] items-center justify-center rounded-[16px] bg-canvas-lilac px-6 py-10 sm:px-10 ${visualFirst ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-1051" data-mp="e4w7icewbh7q">
                  <ProductVisualView visual={feature.visual} className="flex w-full justify-center" data-id="element-1052" data-mp="3h8nom6tliz9a" />
                </div>

                <div className={`max-w-[460px] ${visualFirst ? 'lg:order-2' : 'lg:order-1 lg:justify-self-end'}`} data-id="element-1053" data-mp="3cb5ck7ka83x2">
                  <h3 className="display text-[26px] font-semibold text-ink sm:text-[30px]" data-id="element-1054" data-mp="2kjpqcemn0j7d">
                    {feature.title}
                  </h3>
                  <p className="mt-4 text-[16px] leading-[1.6] text-ink-muted" data-id="element-1055" data-mp="2yc5p338i9v2h">{feature.copy}</p>
                  <ul className="mt-6 space-y-3 border-t border-canvas-line pt-6" data-id="element-1056" data-mp="2tikwxrtlfvb7">
                    {feature.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3 text-[15px] leading-[1.5] text-ink-soft" data-id="element-1057" data-mp="20vqh587q1k42">
                        <span className="mt-[3px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-brand-soft" data-id="element-1058" data-mp="4qhm7bqmk6ua">
                          <CheckIcon className="h-3 w-3 text-brand" strokeWidth={2.5} aria-hidden="true" data-id="element-1059" data-mp="ej6mrbkn00au" />
                        </span>
                        {bullet}
                      </li>)}
                  </ul>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}